import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { corporateHost } from "~/Utils";
import { useAccreditationAndCertifications } from "../TraningAcademy.hook";
import { fieldsReady } from "../constants";

export const AccreditationAndCertifications = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();
  const [fieldData, setFieldData] = useState<any>();

  async function fetchData() {
    try {
      const resolvedFields = await fieldsReady();
      console.log("fieldsReady", resolvedFields);
      setFieldData(resolvedFields);
    } catch (error) {
      console.error("Error fetching fields:", error);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  const {
    data: editData,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchEditData,
  } = useAccreditationAndCertifications();

  const {
    data: dataById,
    isLoading: isLoadingData,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (!query.get("id")) {
      refetchEditData();
    }
  }, []);

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
  }, [query.get("id")]);

  const AwardsFormConfig: FormConfig = {
    initialValues: {
      field_certifications_title: dataById
        ? decodeHTML(dataById.payload.field_certifications_title)
        : editData
          ? decodeHTML(editData?.[0]?.field_certifications_title)
          : "",
      field_certifications_title_ms: dataById
        ? decodeHTML(dataById.payload.field_certifications_title_ms)
        : editData
          ? decodeHTML(editData?.[0]?.field_certifications_title_ms)
          : "",
      field_certifications_title_zhans: dataById
        ? decodeHTML(dataById.payload.field_certifications_title_zhans)
        : editData
          ? decodeHTML(editData?.[0]?.field_certifications_title_zhans)
          : "",
      field_desc: dataById
        ? decodeHTML(dataById.payload.field_desc)
        : editData
          ? decodeHTML(editData?.[0]?.field_desc)
          : "",
      field_desc_ms: dataById
        ? decodeHTML(dataById.payload.field_desc_ms)
        : editData
          ? decodeHTML(editData?.[0]?.field_desc_ms)
          : "",
      field_desc_zhans: dataById
        ? decodeHTML(dataById.payload.field_desc_zhans)
        : editData
          ? decodeHTML(editData?.[0]?.field_desc_zhans)
          : "",
      video_link_1: dataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "video_link_1.mp4",
              status: "done",
              url: dataById?.payload?.video_link_1,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "video_link_1.mp4",
              status: "done",
              url: editData?.[0]?.video_link_1,
            },
          ]),
      video_link_2: dataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "video_link_2.mp4",
              status: "done",
              url: dataById?.payload?.video_link_2,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "video_link_2.mp4",
              status: "done",
              url: editData?.[0]?.video_link_2,
            },
          ]),
      field_images: dataById?.payload
        ? decodeHTML(
            dataById?.payload?.field_images?.map((img: any, index: number) => ({
              uid: `${index + 1}`,
              name: `image.png`,
              status: "done",
              url: img,
            }))
          )
        : decodeHTML(
            editData?.[0]?.field_images?.map((img: any, index: number) => ({
              uid: `${index + 1}`,
              name: `image.png`,
              status: "done",
              url: img,
            }))
          ),
    },
    fields: fieldData?.accreditationAndCertifications,
  };

  console.log("trainingFacilities", AwardsFormConfig.fields, AwardsFormConfig.initialValues);

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let imageKeys: any = ["icon", "video_link_2", "video_link_1"];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "CORPORATE");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }

    let multiImageKeys: any = ["field_images"];

    for (const key of multiImageKeys) {
      try {
        const field = data[key];
        if (!Array.isArray(field)) continue;

        const processedUrls: string[] = [];

        for (const file of field) {
          if (file.originFileObj) {
            const formData = new FormData();
            formData.append("upload-file", file.originFileObj);
            formData.append("application", "CORPORATE");

            const res: any = await post("management/upload-file", formData);
            if (res?.response?.data) {
              processedUrls.push(res.response.data);
            }
          } else if (file.url) {
            processedUrls.push(file.url);
          }
        }

        data[key] = processedUrls;
      } catch (error) {
        console.error("error");
      }
    }

    let numberKeys: any = ["year", "sequence", "field_awards_sequence", "field_awards_year"];

    for (const key of numberKeys) {
      try {
        let field = data[key];
        if (field !== undefined && field !== null && field !== "") {
          data[key] = Number(field);
        }
      } catch (error) {
        console.error(`Error converting ${key} to number:`, error);
      }
    }
    console.log("trainingdatas", data);

    const payload = {
      action: action,
      method: method,
      module: "Malaysia Airport Academy",
      subModule: "accreditationAndCertifications",
      type: "DEDICATED",
      application: "MAHB_CORPORATE",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAHB_CORPORATE",
          apiUrl: apiUrl,
        },
      ],
      moduleKey: "MAHB_CORPORATE_Malaysia Airport Academy_Accreditation & Certifications",
      payload: {
        ...(action === "UPDATE" && { id: editData?.[0]?.id || dataById?.payload?.id }),
        ...data,
        published: true,
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <DynamicForm
      isLoading={isLoadingData || drilldownLoading}
      config={AwardsFormConfig}
      onSubmit={(data, buttonValue, reviewNotes) =>
        onSubmit(
          data,
          `${corporateHost}/api/airports-acad-ertificatin/${editData?.[0]?.id || dataById?.payload?.id}`,
          "UPDATE",
          "PATCH",
          buttonValue === "save" ? "DRAFT" : "PENDING",
          reviewNotes
        )
      }
      defaultReviewNotes="Kindly review this Malaysia Airports Academy"
    />
  );
};
